import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { UserRepository } from "../../user/user.repository";
import { NotifyService } from "../../notify/notify.service";
import { TOAST } from "../../notify/toast/toast-type.enum";
import { environment } from "environments/environment";
import { ButtonDirective } from "primeng/button";

@Component({
  selector: "app-msal-login",
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./msal-login.component.html",
  imports: [ButtonDirective],
})
export class MsalLoginComponent {
  private userRepository = inject(UserRepository);
  private notifyService = inject(NotifyService);

  public login(): void {
    this.userRepository.initiateMsGraphAuthorize().subscribe({
      next: ({ url }) => {
        window.location.assign(url);
      },
      error: (err: HttpErrorResponse) => {
        if (err.url && !err.url.startsWith(environment.apiUrl)) {
          window.location.assign(err.url);
        } else {
          this.notifyService.toast(
            TOAST.ERROR,
            "Office365 Authorization Failed",
            err.message,
          );
        }
      },
    });
  }
}
